import GradePage from "@/pages/GradePage";
export default function GradeKindergarten() {
  return <GradePage grade="K" />;
}
